import { Outlet, useRoutes } from "react-router-dom";
import SidebarLayout from "components/wrappers/SidebarLayout";

import Home from "pages/Home";
import Login from "pages/Auth/Login";
import AuthLayout from "components/wrappers/AuthLayout";
import ForgotPassword from "pages/Auth/ForgotPassword";
import ResetPassword from "pages/Auth/ResetPassword";
import Activity from "pages/Activity";
import ProtectedOutlet from "components/wrappers/ProtectedOutlet";
import Notifications from "pages/notifications";
import Shifts from "pages/Shifts";
import Reports from "pages/Reports";
import Settings from "pages/settings";
import Users from "pages/settings/Users";
import VerifyCode from "pages/Auth/VerifyCode";
import StaffDirectory from "pages/StaffDirectory";
import MyProfile from "pages/MyProfile";
import useOrganizationRoutes from "./organizationRoutes";
import useUserAccessControlRoutes from "./userAccessControlRoutes";
import calenderRoutes from "./calenderRoutes";
import staffRoutes from "./staffRoutes";
import requestsRoutes from "./requestsRoutes";
import setupsRoutes from "./setupsRoutes";
import integrationRotues from "./integrationRoutes";

export default function useGenerateRoutes() {
  const routes = [
    {
      path: "/",
      element: (
        <SidebarLayout>
          <ProtectedOutlet />
        </SidebarLayout>
      ),
      children: [
        // Main Screens
        {
          path: "",
          element: (
            <ProtectedOutlet requiredPermission="view_dashboard">
              <Home />
            </ProtectedOutlet>
          ),
        },
        {
          path: "staff",
          element: (
            <ProtectedOutlet requiredPermission="view_staff_directory">
              <Users />
            </ProtectedOutlet>
          ),
          children: [
            {
              path: "",
              element: <Users />,
            },
          ],
        },
        {
          path: "shifts",
          element: (
            <ProtectedOutlet requiredPermission="view_shift_assignment">
              <Shifts />
            </ProtectedOutlet>
          ),
        },
        {
          path: "settings",
          element: (
            <ProtectedOutlet>
              <Settings />
            </ProtectedOutlet>
          ),
        },
        {
          path: "staff-directory",
          element: (
            <ProtectedOutlet requiredPermission="view_staff_directory">
              <StaffDirectory />
            </ProtectedOutlet>
          ),
        },
        {
          path: "my-profile",
          element: (
            <ProtectedOutlet>
              <MyProfile />
            </ProtectedOutlet>
          ),
        },
        {
          path: "activity",
          element: (
            <ProtectedOutlet requiredPermission="view_activity">
              <Activity />
            </ProtectedOutlet>
          ),
        },
        {
          path: "notifications",
          element: (
            <ProtectedOutlet requiredPermission="view_notifications">
              <Notifications />
            </ProtectedOutlet>
          ),
        },
        {
          path: "reports",
          element: (
            <ProtectedOutlet requiredPermission="view_reports">
              <Reports />
            </ProtectedOutlet>
          ),
        },
        useUserAccessControlRoutes(),
        useOrganizationRoutes(),
        calenderRoutes(),
        requestsRoutes,
        setupsRoutes,
        integrationRotues(),
        staffRoutes(),
      ],
    },
    {
      path: "/auth/",
      element: (
        <AuthLayout>
          <Outlet />
        </AuthLayout>
      ),
      children: [
        {
          path: "",
          element: <Login />,
        },
        {
          path: "forgot-password",
          element: <ForgotPassword />,
        },
        {
          path: "verify-code",
          element: <VerifyCode />,
        },
        {
          path: "reset-password",
          element: <ResetPassword />,
        },
      ],
    },
  ];

  return useRoutes(routes);
}
